import component from '../../../../../pages/vip/features/header-top-brand/header-description.desktop';

export default component;
